<template>
  <div id="dashboardChannelMilestones">
    <div id="channelsGrid" class="CustomGrid">
      <DxDataGrid
        v-if="dataReady"
        ref="channelsGrid"
        :data-source="Dmachannels"
        :remote-operations="false"
        :show-borders="false"
        :show-row-lines="true"
        :show-column-lines="true"
        mode="single"
        @cell-prepared="onCellPrepared"
        :rowAlternationEnabled="true"
        @toolbar-preparing="onToolbarPreparing"
        :onContentReady="onContentReady"
        :wordWrapEnabled="true"
        :onExporting="onExporting"
        :onExported="onExported"
      >
        <DxPaging :page-size="GridType == 'OnPortfolio' ? 50 : 10" />
        <DxPager
          :show-page-size-selector="true"
          :allowed-page-sizes="[5, 10, 20, 50]"
          :show-info="true"
        />
        <DxFilterRow :visible="true" />
        <DxHeaderFilter :visible="true" />
        <DxSearchPanel :visible="true" :width="240" placeholder="Search..." />
        <DxColumn
          data-field="ProductInstanceID"
          caption="Product Instance ID"
          data-type="number"
          :width="65"
          alignment="left"
          :fixed="true"
          :visible="false"
        />
        <DxColumn
          data-field="DMA_RecID"
          caption="DMA_RecID"
          data-type="number"
          :width="65"
          alignment="left"
          :fixed="true"
          :visible="false"
        />
        <!-- <DxColumn
          data-field="OrderRequestName"
          caption="Channel Requested"
          data-type="string"
          :allowHeaderFiltering="true"
          :header-filter="{ allowSearch: true }"
          alignment="left"
          :fixed="true"
          :visible="true"
          :sortOrder="'asc'"
          :minWdith="225"
        />   -->
        <DxColumn
          data-field="OrderRequestName"
          caption="Channel Requested"
          data-type="string"
          width="200"
          :allowHeaderFiltering="true"
          :header-filter="{ allowSearch: true }"
          alignment="left"
          :fixed="true"
          cell-template="Channel-Requested-template"
        />
        <template #Channel-Requested-template="cell">
          <div style="display: flex">
            <span v-if="$route.name == 'Events To Dashboard via Event Details'">
              <router-link
                :to="{
                  name: 'Events To ChannelDetails via Event Details and Dashboard',
                  params: {
                    id: cell.data.data.DMA_RecID,
                    eventId: $route.params.eventId,
                    instanceId: cell.data.data.ProductInstanceID,
                  },
                }"
                ><span
                  v-if="cell.data.data != null"
                  style="text-decoration: underline; cursor: pointer"
                  @click="redirectToChannelDetails(cell.data.data)"
                >
                  <span>
                    <ChannelNamePopup
                      :channelNamePopupRowData="cell.data.data"
                      :displayChannelName="cell.data.data.OrderRequestName"
                      :channelNameType="``"
                    />
                  </span>
                </span>
              </router-link>
            </span>
            <span
              v-else-if="$route.name == 'Home Channels to Market Dashboard'"
            >
              <router-link
                :to="{
                  name: 'Channels Dashboard to Channel Details',
                  params: {
                    id: cell.data.data.DMA_RecID,
                    instanceId: cell.data.data.ProductInstanceID,
                  },
                }"
                ><span
                  v-if="cell.data.data != null"
                  style="text-decoration: underline; cursor: pointer"
                  @click="redirectToChannelDetails(cell.data.data)"
                >
                  <span>
                    <ChannelNamePopup
                      :channelNamePopupRowData="cell.data.data"
                      :displayChannelName="cell.data.data.OrderRequestName"
                      :channelNameType="``"
                    />
                  </span>
                </span>
              </router-link>
            </span>
            <span v-else-if="$route.name == 'Event Details To Dashboard'">
              <router-link
                :to="{
                  name: 'Event Details To Channel Details via Dashboard',
                  params: {
                    id: cell.data.data.DMA_RecID,
                    eventId: $route.params.eventId,
                    instanceId: cell.data.data.ProductInstanceID,
                  },
                }"
                ><span
                  v-if="cell.data.data != null"
                  style="text-decoration: underline; cursor: pointer"
                  @click="redirectToChannelDetails(cell.data.data)"
                >
                  <span>
                    <ChannelNamePopup
                      :channelNamePopupRowData="cell.data.data"
                      :displayChannelName="cell.data.data.OrderRequestName"
                      :channelNameType="``"
                    />
                  </span>
                </span>
              </router-link>
            </span>
            <span v-else-if="GridType == 'OnDashboard'">
              <router-link
                :to="{
                  name: 'Dashboard Channel Details',
                  params: {
                    id: cell.data.data.DMA_RecID,
                    instanceId: cell.data.data.ProductInstanceID,
                  },
                }"
                ><span
                  v-if="cell.data.data != null"
                  style="text-decoration: underline; cursor: pointer"
                  @click="redirectToChannelDetails(cell.data.data)"
                >
                  <span>
                    <ChannelNamePopup
                      :channelNamePopupRowData="cell.data.data"
                      :displayChannelName="cell.data.data.OrderRequestName"
                      :channelNameType="``"
                    />
                  </span>
                </span>
              </router-link>
            </span>
            <span v-else>
              <router-link
                :to="{
                  name: 'Channel Details',
                  params: {
                    instanceId: cell.data.data.ProductInstanceID,
                  },
                }"
                ><span
                  v-if="cell.data.data != null"
                  style="text-decoration: underline; cursor: pointer"
                  @click="redirectToChannelDetails(cell.data.data)"
                >
                  <span>
                    <ChannelNamePopup
                      :channelNamePopupRowData="cell.data.data"
                      :displayChannelName="cell.data.data.OrderRequestName"
                      :channelNameType="``"
                    />
                  </span>
                </span>
              </router-link>
            </span>
          </div>
        </template>
        <DxColumn
          data-field="ClientReferenceID"
          caption="DSrcID"
          data-type="string"
          width="115"
          :allowHeaderFiltering="true"
          :header-filter="{ allowSearch: true }"
          alignment="left"
          :fixed="true"
          :visible="true"
        />
        <DxColumn
          data-field="DMA_Name"
          caption="Market"
          data-type="string"
          width="210"
          :allowHeaderFiltering="true"
          :header-filter="{ allowSearch: true }"
          alignment="left"
          :fixed="true"
          cell-template="DMA-channel-cell-template"
          :calculate-cell-value="DMAValueCalculate"
          :visible="GridType == 'OnPortfolio'"
        />
        <template #DMA-channel-cell-template="cell">
          <div>
            <router-link :to="`market-dashboard/${cell.data.data.DMA_RecID}`">
              <span
                v-if="cell.data.data != null"
                style="text-decoration: underline; cursor: pointer"
                :title="`${
                  cell.data.data.DMA_Name ? cell.data.data.DMA_Name : ''
                }`"
                @click="resetDMADashboard()"
              >
                {{ cell.data.data.DMA_Name }}
              </span>
            </router-link>
            <!-- <span v-if="cell.data.data.DMA_Rank"> ({{ cell.data.data.DMA_Rank }})</span> -->
          </div>
        </template>
        <DxColumn
          data-field="DMA_Rank"
          caption="Market Rank"
          data-type="number"
          width="95"
          :allowHeaderFiltering="false"
          :header-filter="{ allowSearch: true }"
          alignment="left"
          :fixed="true"
          :visible="GridType == 'OnPortfolio'"
        />
        <!-- <DxColumn
          data-field="ProjectedStartDate"
          caption="Projected Start Date"
          data-type="date"
          width="135"
          :allowHeaderFiltering="true"
          :header-filter="{ dataSource: dateFilter('ProjectedStartDate') }"
          alignment="left"
          :fixed="true"
          :visible="true"
        /> -->
        <DxColumn
          data-field="PromiseDate"
          caption="Promise Activation Date"
          data-type="date"
          width="135"
          :allowHeaderFiltering="true"
          :header-filter="{ dataSource: dateFilter('PromiseDate') }"
          alignment="left"
          :fixed="true"
          :visible="true"
        />
        <DxColumn
          data-field="ProjectedActivationDate"
          caption="Activation Date*"
          data-type="date"
          width="135"
          :allowHeaderFiltering="true"
          :header-filter="{ dataSource: dateFilter('ProjectedActivationDate') }"
          alignment="left"
          :fixed="true"
          :visible="true"
          headerCellTemplate="ActivationCellHeaderTemplate"
          cell-template="activationDateTemplate"
          sortOrder="asc"
        />
        <DxColumn
          data-field="BillingEffectiveDate"
          caption="Billing Effective Date"
          data-type="date"
          width="200"
          :allowHeaderFiltering="true"
          :header-filter="{ dataSource: dateFilter('BillingEffectiveDate') }"
          alignment="left"
          :fixed="true"
          :visible="false"
        />
        <DxColumn
          data-field="MilestoneStatusName"
          caption="Current Status"
          data-type="string"
          width="110"
          :allowHeaderFiltering="true"
          :header-filter="{ allowSearch: true }"
          alignment="left"
          :fixed="true"
          :visible="true"
          cell-template="CurrStatus"
        />
        <DxColumn
          data-field="ClientProjectName"
          caption="Project"
          data-type="string"
          width="115"
          :allowHeaderFiltering="true"
          :header-filter="{ allowSearch: true }"
          alignment="left"
          :fixed="true"
          :visible="GridType == 'OnPortfolio'"
        />
        <DxColumn
          data-field="PhaseName"
          caption="Phase"
          data-type="string"
          width="115"
          :allowHeaderFiltering="true"
          :header-filter="{ allowSearch: true }"
          alignment="left"
          :fixed="true"
          :visible="GridType == 'OnPortfolio'"
        />
        <DxColumn
          data-field="CurrentMilestoneName"
          caption="Current Milestone"
          data-type="string"
          width="135"
          :allowHeaderFiltering="true"
          :header-filter="{ allowSearch: true }"
          alignment="left"
          :fixed="true"
          :visible="true"
          cell-template="CurrentMilestoneTemplate"
          header-cell-template="currMilestoneHeaderTemplate"
        />
        <DxColumn
          data-field="SRT_PublicPort"
          caption="SRT_PublicPort"
          data-type="string"
          width="200"
          :visible="false"
        />
        <DxColumn
          data-field="SRT_PublicIP"
          caption="IP Address"
          data-type="string"
          width="150"
          :allowHeaderFiltering="true"
          :header-filter="{ allowSearch: true }"
          alignment="left"
          :fixed="true"
          cell-template="IPAdress_CellTemplate"
          :calculate-cell-value="IPAdressCalculate"
        />
        <!--    <DxColumn
          data-field=" "
          caption="Actions"
          :allowHeaderFiltering="false"
          :allowFiltering="false"
          width="85"
          alignment="center"
          cell-template="actionsTemplate"
          :fixed="true"
          :visible="GridType == 'OnDashboard'"
        /> -->
        <DxColumn
          data-field="ProductInstanceID"
          caption="InstanceID"
          data-type="number"
          :width="65"
          alignment="left"
          :fixed="true"
          :visible="false"
        />
        <template #activationDateTemplate="cell">
          <div v-if="cell.data.value">
            <span style="padding-left: 6px">{{
              cell.data.value.toLocaleString().split(",")[0]
            }}</span>
            <span v-if="cell.data.data.ProjectedFlag === true">*</span>
          </div>
        </template>
        <template #ActivationCellHeaderTemplate="data">
          <div>
            <span
              title="*Projected"
              style="color: grey; font-weight: bold; font-size: 16px"
            >
              {{ data.data.column.caption }}
            </span>
          </div>
        </template>
        <template #IPAdress_CellTemplate="cell">
          <div
            v-if="
              cell.data.data.PublicIP !== null &&
              cell.data.data.PublicPort != null
            "
          >
            {{ `${cell.data.data.PublicIP}:${cell.data.data.PublicPort}` }}
          </div>
        </template>
        <template #CurrentMilestoneTemplate="cell">
          <div>
            <div
              class="underlineMilestone"
              @click="showMilestoneDetails(cell.data.row.data)"
            >
              {{ cell.data.data.CurrentMilestoneName }}
            </div>
          </div>
        </template>
        <template #CurrStatus="cell">
          <div>
            <font-awesome-icon
              :style="{ color: cell.data.row.data.MilestoneStatusColor }"
              icon="circle"
            ></font-awesome-icon>
            <span style="padding-left: 6px">{{ cell.data.value }}</span>
          </div>
        </template>
        <!--   <template #actionsTemplate="cell">
          <div style="display:flex;text-align:center;">
          <span style="margin:auto;">
            <DxMenu
              :items="actionOptions"
              :show-first-submenu-mode="showSubmenuModes[0]"
              display-expr="name"
              :hide-submenu-on-mouse-leave="true"
              @item-click="itemClick($event,cell.data.row.data)"
            >
            <template #actionsIcon= "">
              <div> <font-awesome-icon
                style="color:grey; font-size:16px;width:55px;"
                :icon="['far', 'ellipsis-v']"
              ></font-awesome-icon> </div>
            </template>
            </DxMenu>
          </span>
          </div>
        </template> -->
        <template #currMilestoneHeaderTemplate>
          <div style="display: flex">
            <span>Current Milestone</span>
            <span style="padding-left: 10px">
              <font-awesome-icon
                style="color: grey; font-size: 16px; width: 16px"
                :icon="['fa', 'circle-info']"
                @click="showisCurrentMilestonePopupVisible()"
              ></font-awesome-icon>
            </span>
          </div>
        </template>
        <template #ClearBtn>
          <DxButton
            icon="fas fa-filter"
            hint="Clear All Filters"
            styling-mode="contained"
            :elementAttr="{ id: 'ClearAllBtn' }"
            :ref="'ClearAllBtnRef'"
            @click="clearDataGridFilters()"
            :disabled="!isFiltered"
          />
        </template>
        <template #QuickFilters>
          <DxButtonGroup
            :items="MilestoneFilterBtns"
            styling-mode="outlined"
            :selected-item-keys="selectedMilestoneFilter"
            key-expr="text"
            @item-click="filterByMilestone"
            button-template="milestoneFilterTemplate"
          >
            <template #milestoneFilterTemplate="{ data }">
              <div style="display: flex">
                <div v-if="data.text != 'All'">
                  <font-awesome-icon
                    :style="{ fontSize: '14px', color: data.color }"
                    icon="circle"
                  ></font-awesome-icon>
                </div>
                <div class="milestoneFilter">{{ data.text }}</div>
              </div>
            </template>
          </DxButtonGroup>
        </template>
      </DxDataGrid>
      <div>
        <customModal
          id="milestoneDetails"
          title="Milestone Details"
          :show.sync="showMilestoneDetailsPopup"
          :centered="true"
          :backdrop="true"
          :closeOnBackdrop="false"
          width="70%"
          :CCRColoBrand="true"
        >
          <MilestoneDetailsPopup
            v-if="showMilestoneDetailsPopup"
            :milestoneDetailsRowData="milestoneDetailsRowData"
          />
        </customModal>

        <CustomModal
          :title="`Milestone`"
          :show.sync="isCurrentMilestonePopupVisible"
          :centered="true"
          :closeOnBackdrop="false"
          :backdrop="true"
          width="80%"
          :CCRColoBrand="true"
        >
          <CurrentMilestone v-if="isCurrentMilestonePopupVisible" />
        </CustomModal>
      </div>
    </div>
  </div>
</template>

<script>
const actionOptions = [
  {
    id: "1",
    name: "",
    template: "actionsIcon",
    items: [
      {
        id: "1_1",
        name: "Milestone Details",
        disabled: false,
      },
      {
        id: "1_2",
        name: "Channel Details",
        disabled: true,
      },
      {
        id: "1_3",
        name: "Channel Verification",
        disabled: true,
      },
    ],
  },
];
const showSubmenuModes = [
  {
    name: "onHover",
    delay: { show: 0, hide: 0 },
  },
];
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxPager,
  DxHeaderFilter,
  DxSearchPanel,
  DxFilterRow,
} from "devextreme-vue/data-grid";
import "devextreme/data/odata/store";
import { DxButton } from "devextreme-vue/button";
import { DxButtonGroup } from "devextreme-vue/button-group";
import DxMenu from "devextreme-vue/menu";
import { getDateFilter } from "../../../../sharedCode/dateHandler";
import MilestoneDetailsPopup from "../MilestoneDetailsPopup.vue";
import CurrentMilestone from "../../../portfolio/CurrentMilestonePopup.vue";
import { EventBus } from "../../../../components/Events";
import ChannelNamePopup from "../ChannelNamePopup.vue";
export default {
  name: "NonCCRChannelList",
  props: {
    ["Dmachannels"]: Object,
    GridType: String,
    milestoneFilter: Array,
    clientProjectName: String,
    milestoneStatus: String,
    milestoneStatusID: String,
  },
  components: {
    DxDataGrid,
    DxColumn,
    DxHeaderFilter,
    DxFilterRow,
    DxSearchPanel,
    DxPaging,
    DxPager,
    DxButton,
    DxButtonGroup,
    DxMenu,
    MilestoneDetailsPopup,
    CurrentMilestone,
    ChannelNamePopup,
  },
  data() {
    return {
      dataReady: true,
      mergelements: [],
      isFiltered: false,
      MilestoneFilterBtns: this.milestoneFilter,
      selectedMilestoneFilter: ["All"],
      actionOptions,
      showSubmenuModes,
      showMilestoneDetailsPopup: false,
      milestoneDetailsRowData: null,
      isCurrentMilestonePopupVisible: false,
    };
  },
  created() {},
  methods: {
    IPAdressCalculate(rowData) {
      if (rowData.PublicIP && rowData.PublicPort)
        return rowData.PublicIP + ":" + rowData.PublicPort;
      return "";
    },
    DMAValueCalculate(rowData) {
      return rowData.DMA_Name;
    },
    onExporting(e) {
      e.component.beginUpdate();
      e.component.columnOption("BillingEffectiveDate", "visible", true);
      e.component.columnOption("ProductInstanceID", "visible", true);
    },
    onExported(e) {
      e.component.columnOption("BillingEffectiveDate", "visible", false);
      e.component.columnOption("ProductInstanceID", "visible", false);
      e.component.endUpdate();
    },
    showisCurrentMilestonePopupVisible() {
      this.isCurrentMilestonePopupVisible = true;
    },
    filterByMilestone(e) {
      var gridSelector = this.$refs["channelsGrid"]?.instance;
      if (e.itemData != undefined) {
        if (e.itemData.filter != undefined && e.itemData.filter != "all") {
          gridSelector?.filter([
            "MilestoneStatusID",
            "=",
            e.itemData.filter ? [e.itemData.filter] : undefined,
          ]);
        } else {
          this.clearDataGridFilters();
        }
      }
      if (this.GridType == "OnPortfolio") {
        EventBus.$emit("filter-On-Channel", e.itemData);
      }
    },
    showMilestoneDetails(data) {
      this.showMilestoneDetailsPopup = true;
      this.milestoneDetailsRowData = data;
    },
    onContentReady(e) {
      if (e.component.getCombinedFilter() == undefined) {
        this.isFiltered = false;
      } else {
        this.isFiltered = true;
      }
    },
    filterGridByClientProjectID(selectedClientProjectID) {
      var gridSelector = this.$refs["channelsGrid"]?.instance;
      gridSelector?.filter(["ClientProjectID", "=", selectedClientProjectID]);
    },
    onToolbarPreparing: function (e) {
      var toolbarItems = e.toolbarOptions.items;
      for (var i = 0; i < e.toolbarOptions.items.length; i++) {
        if (e.toolbarOptions.items[i].name == "searchPanel") {
          e.toolbarOptions.items[i].location = "before";
        }
      }
      var customButtons = [
        {
          location: "before",
          template: "ClearBtn",
        },
        {
          location: "before",
          widget: "dxButton",
          options: {
            hint: "Export to Excel",
            icon: "fad fa-file-excel",
            onClick: this.ExportDataGrid.bind(this),
            elementAttr: { id: "ExcelBtn" },
          },
        },
        {
          location: "before",
          widget: "dxButton",
          options: {
            hint: "Refresh Grid",
            icon: "fad fa-sync",
            onClick: this.refreshDataGrid.bind(this),
            elementAttr: { id: "RefreshBtn" },
          },
        },
        {
          location: "before",
          template: "QuickFilters",
        },
      ];
      toolbarItems.push(...customButtons);
    },
    dateFilter(date) {
      return getDateFilter(date);
    },
    clearDataGridFilters() {
      this.$refs["channelsGrid"]?.instance.clearFilter();
      this.selectedMilestoneFilter = ["All"];
    },
    refreshDataGrid() {
      this.$refs["channelsGrid"]?.instance.refresh();
    },
    refreshDataGridFilter() {
      this.$refs["channelsGrid"]?.instance.refresh();
      if (
        this.clientProjectName != undefined &&
        this.milestoneStatus != undefined &&
        this.milestoneStatusID != undefined
      ) {
        //if(this.PlanObjectID == 5){
        var gridSelector = this.$refs["channelsGrid"]?.instance;
        this.selectedMilestoneFilter = [this.milestoneStatus];
        if (this.milestoneStatusID == "all") {
          gridSelector.clearFilter();
          this.selectedMilestoneFilter = ["All"];
        } else {
          gridSelector?.filter([
            "MilestoneStatusID",
            "=",
            parseInt(this.milestoneStatusID),
          ]);
        }
        if (this.clientProjectName != "NA") {
          gridSelector.columnOption("ClientProjectName", "filterValues", [
            this.clientProjectName,
          ]);
        }
        //}
      }
    },
    ExportDataGrid() {
      this.$refs["channelsGrid"]?.instance.exportToExcel(false);
    },
    onCellPrepared: function (e) {
      let mergelements = this.mergelements;
      if (isNaN(e.rowIndex)) return;
      var MergeColumns = ["SiteName"];

      if (e.rowType == "data") {
        if (
          e.rowIndex > 0 &&
          e.column.command != "edit" &&
          MergeColumns.includes(e.column.dataField)
        ) {
          if (
            e.component.cellValue(e.rowIndex - 1, e.column.dataField) == e.value
          ) {
            if (
              e.component.cellValue(e.rowIndex - 1, e.column.dataField) !=
              undefined
            ) {
              var prev = mergelements[e.rowIndex - 1][e.column.dataField];
              if (!mergelements[e.rowIndex]) mergelements[e.rowIndex] = {};
              mergelements[e.rowIndex][e.column.dataField] = prev;
              if (prev) {
                e.cellElement.style.display = "none";
                var span = prev.getAttribute("rowspan");
                if (span) prev.setAttribute("rowspan", Number(span) + 1);
                else prev.setAttribute("rowspan", 2);
                prev.style.verticalAlign = "top";
              }
            } else {
              if (!mergelements[e.rowIndex]) mergelements[e.rowIndex] = {};
              mergelements[e.rowIndex][e.column.dataField] = e.cellElement;
            }
          } else {
            if (!mergelements[e.rowIndex]) mergelements[e.rowIndex] = {};
            mergelements[e.rowIndex][e.column.dataField] = e.cellElement;
          }
        } else {
          if (!mergelements[e.rowIndex]) mergelements[e.rowIndex] = {};
          mergelements[e.rowIndex][e.column.dataField] = e.cellElement;
        }
      }
    },
    resetDMADashboard() {
      //reset DMA Details filter to Dashboard and not Project
      setTimeout(() => {
        EventBus.$emit("DMA-Filter", "Dashboard");
      }, 1);
    },
    redirectToChannelDetails(data) {
      setTimeout(() => {
        EventBus.$emit("channel-requested", data);
      }, 1);
    },
  },
  mounted: function () {
    EventBus.$on("filter-On-Milestone", (filterData) => {
      if (
        filterData != undefined &&
        filterData.filter != "all" &&
        filterData.filter != undefined
      ) {
        var gridSelector = this.$refs["channelsGrid"]?.instance;
        gridSelector?.filter(["MilestoneStatusID", "=", filterData?.filter]);
        this.selectedMilestoneFilter.splice(0);
        this.selectedMilestoneFilter.push(filterData.text);
      } else {
        this.clearDataGridFilters();
      }
    });
    this.refreshDataGridFilter();
  },
};
</script>

<style lang="scss" scoped>
.topLeftCell {
  text-align: left !important;
  vertical-align: top !important;
}
.milestoneFilter {
  padding-top: 7px;
  padding-left: 6px;
  text-transform: uppercase;
}
.milestone {
  text-decoration: underline;
  text-decoration-style: dotted;
  text-decoration-color: gray;
}
#channelsGrid::v-deep {
  .dx-datagrid .dx-column-indicators .dx-sort-index-icon {
    display: none !important;
  }
}
.underlineMilestone {
  text-decoration-line: underline;
  text-decoration-style: dashed;
  cursor: pointer;
  text-underline-offset: 4px;
}
#channelsGrid::v-deep {
  .dx-datagrid .dx-column-indicators .dx-header-filter,
  .dx-datagrid .dx-sort-down,
  .dx-datagrid .dx-sort-up {
    color: grey;
  }
  .dx-datagrid-headers
    .dx-datagrid-table
    .dx-row
    > td
    .dx-datagrid-text-content {
    color: grey;
  }
}
</style>